import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const without = ['Seguir aguantando sola', 'Pagar $200+ en consultas médicas', 'Probar suplementos al azar', 'Esperar que "se pase"', 'Sentirte invisible'];
const withGuide = ['Plan claro día por día', 'Solo $10 pago único', 'Pasos simples comprobados', 'Tu energía de vuelta', 'Comunidad de apoyo'];
export function Comparison() {
  return <section className="w-full bg-wine px-5 py-10 md:py-16" aria-labelledby="comparison-heading" data-id="element-27">
      <div className="mx-auto max-w-container" data-id="element-28">
        <h2 id="comparison-heading" className="font-serif italic text-[22px] font-medium text-cream md:text-[26px]" data-id="element-29">
          Dos caminos. Tú decides.
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-30">
          {/* Without */}
          <div className="rounded-[12px] p-5" style={{
          background: 'rgba(255,255,255,0.08)'
        }} data-id="element-31">
            <p className="text-[11px] font-medium uppercase" style={{
            letterSpacing: '1.5px',
            color: '#ED93B1'
          }} data-id="element-32">
              Sin la guía
            </p>
            <ul className="mt-4 flex flex-col gap-3" data-id="element-33">
              {without.map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-pinkLight" data-id="element-34">
                  <XIcon size={16} className="mt-0.5 shrink-0 text-pinkMed" strokeWidth={2.5} data-id="element-35" />
                  <span data-id="element-36">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="rounded-[12px] bg-cream p-5" data-id="element-37">
            <p className="text-[11px] font-medium uppercase" style={{
            letterSpacing: '1.5px',
            color: '#993556'
          }} data-id="element-38">
              Con la guía
            </p>
            <ul className="mt-4 flex flex-col gap-3" data-id="element-39">
              {withGuide.map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-wine" data-id="element-40">
                  <CheckIcon size={16} className="mt-0.5 shrink-0 text-success" strokeWidth={3} data-id="element-41" />
                  <span data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}